var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightJawwalPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.09 43.35c.022-.072.038-.124.056-.176 1.136-3.22 2.273-6.44 3.41-9.655.069-.17.153-.333.25-.488a.6.6 0 0 1 .505-.316c.315-.014.632-.01.947.008.183.01.348.111.442.268.102.147.188.304.255.47 1.013 2.837 2.02 5.677 3.025 8.518.146.41.285.82.427 1.232.014.04.023.083.035.13-.534 0-1.068.026-1.591-.01-.343-.024-.53-.303-.646-.609a92.987 92.987 0 0 1-.614-1.679.18.18 0 0 0-.2-.144c-1.09.005-2.181.005-3.272 0-.127 0-.17.05-.207.158-.185.548-.377 1.095-.567 1.642-.166.48-.4.652-.903.656-.445-.002-.889-.005-1.352-.005zm4.718-7.59h-.074L20.6 39.143h2.337l-1.128-3.383zM11.884 39.319v3.068c.001.095-.003.19-.014.284-.04.352-.237.596-.588.625-.418.034-.84.008-1.281.008v-9.653a1.94 1.94 0 0 1 .007-.234c.05-.402.267-.631.668-.7.098-.017.198-.026.298-.026h3.37c.575.001 1.131.098 1.647.357.922.47 1.42 1.236 1.585 2.24a4.462 4.462 0 0 1-.147 2.085c-.324 1.022-1.042 1.625-2.076 1.839-.35.066-.704.1-1.06.101-.734.015-1.468.005-2.203.005h-.206zm.008-1.849a.34.34 0 0 0 .067.014c.867 0 1.736 0 2.604-.004.224 0 .442-.072.623-.205.37-.268.5-.656.549-1.083.1-.864-.304-1.713-1.439-1.675-.738.027-1.478.005-2.217.005-.06 0-.117.006-.182.01l-.005 2.938zM28.792 43.345v-.215c0-1.273 0-2.546-.009-3.819a.609.609 0 0 0-.081-.299c-.858-1.447-1.718-2.893-2.582-4.338a524.32 524.32 0 0 1-1.15-1.943c-.025-.038-.046-.083-.08-.15h.734c.284 0 .569.01.852 0 .379-.015.633.168.815.48l2.316 3.971c.029.051.066.099.113.172.049-.073.084-.12.113-.171l2.312-3.993c.164-.282.405-.456.746-.456h1.502a.965.965 0 0 1 .1.012c-.044.076-.078.138-.113.201l-3.596 6.186a.822.822 0 0 0-.117.44c.005 1.006.003 2.01 0 3.015 0 .603-.267.886-.868.906-.322.01-.65 0-1.007 0z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.858 20.588-2.86 6.7-.647 1.512h.003a9.202 9.202 0 0 0 3.566.004 8.432 8.432 0 0 0 2.55-1.097c.096-.064.19-.128.283-.194l-2.895-6.925z",
    fill: "#7BB958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.122 23.531z",
    fill: "#7CBC56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.679 12.594.016 6.073v.001l2.998.935 3.165.985-6.179-7.994z",
    fill: "#226188"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.695 18.668 2.998.935-2.998-.935z",
    fill: "#7CBC56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 5.11A7.807 7.807 0 0 0 15.27 8.1l-.04.054c-.024.032-.046.065-.07.096l6.519 4.341-1.48-7.483z",
    fill: "#29A5BA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.042 22.193 6.408-1.605-5.43-3.031c-1.01 1.842-1.099 3.513-.978 4.636z",
    fill: "#7BB958"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.044 22.23.008.063.013.078c.409 2.41 1.686 3.883 2.566 4.64l3.819-6.423-6.409 1.605c0 .011.003.024.003.037z",
    fill: "#68A855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.897 27.23a.517.517 0 0 1 .044.035l.037.027c1.29.963 2.531 1.582 4.719 1.697a7.85 7.85 0 0 0 1.049-.019c-.586-2.154-2.201-8.076-2.296-8.38v-.002l-3.82 6.424c.095.08.183.153.267.217z",
    fill: "#5B9E54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.745 28.97.002.002c.03-.004.062-.006.093-.008l.06-.007.08-.008c1.355-.158 2.458-.631 3.192-.947.176-.075.33-.142.46-.191-1.49-.906-2.683-2.03-3.605-3.117a17.296 17.296 0 0 1-1.393-1.89 17.693 17.693 0 0 1-.488-.811c-.14-.247-.265-.467-.354-.663-.342-.739-.339-.73-.342-.742",
    fill: "#5A9252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.055 6.467a7.774 7.774 0 0 0-2.357-1.154 5.729 5.729 0 0 0-1.912-.307l-.038-.002a7.711 7.711 0 0 0-1.475.093l-.073.013 1.477 7.482 4.482-6.047c-.034-.026-.067-.053-.104-.078z",
    fill: "#1E98B0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.056 10.8a7.843 7.843 0 0 0-2.898-4.254l-4.481 6.047h.002l7.385-1.766-.008-.028z",
    fill: "#218DA5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.361 13.672-.002.1.002-.1zM21.695 18.668a.797.797 0 0 0-.03.01l.03-.009v-.001z",
    fill: "#7CBC56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.695 18.668a.29.29 0 0 0-.03.01c-.004 0-.006 0 0 0-.315.093-.384.115-6.215 1.91h12.409l-3.166-.985-2.998-.935z",
    fill: "#95C65B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.665 18.677.03-.009-.03.01z",
    fill: "#7CBC56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.702 14.059a.923.923 0 0 1-.018.008c-1.549.788-2.8 1.938-3.527 3.249l-.01.018c-.044.074-.086.149-.127.223l5.43 3.03-1.748-6.528z",
    fill: "#83BD5C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.679 12.591 15.161 8.25a7.83 7.83 0 0 0-1.481 4.274c0 .007-.04.59.02 1.524 0 .004 0 .006.002.008.16-.08.32-.156.479-.224v-.004.004a14.98 14.98 0 0 1 3.642-1.05c.44-.068.883-.119 1.324-.154.865-.069 1.744-.053 2.532-.036v-.001z",
    fill: "#25B3C4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.695 18.666-.016-6.072-6.23 7.994c5.832-1.796 5.901-1.82 6.216-1.912l.03-.01z",
    fill: "#9EC95B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.695 18.667-.016-6.073.016 6.073z",
    fill: "#7CBC56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.45 20.588 6.227-7.994v-.001c-.786-.017-1.665-.033-2.53.036a18.486 18.486 0 0 0-1.7.217 14.99 14.99 0 0 0-3.266.987v-.004.004a8.792 8.792 0 0 0-.48.224H13.7l.002.001 1.748 6.53z",
    fill: "#91C45A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.633 22.805zM16.146 21.992zM16.325 22.303zM15.792 21.33zM15.792 21.33c-.227-.45-.336-.727-.342-.738.006.01.115.288.342.739z",
    fill: "#7CBC56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.858 20.588c-.76.305-1.526.618-2.289.932a449.35 449.35 0 0 0-5.727 2.403l-1.128.48-.006.002-.681.29c.923 1.087 2.114 2.21 3.604 3.116.606.355 1.394.65 2.536.948l.071.018.006.001.107.022c.016.003-.016-.003 0 0l.647-1.511 2.86-6.701z",
    fill: "#83BD5C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.122 22.957z",
    fill: "#7CBC56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.45 20.588v.004c.006.012.115.288.342.739.095.19.214.415.354.663a18.885 18.885 0 0 0 .721 1.166 17.466 17.466 0 0 0 1.16 1.534c.226-.095.453-.193.68-.29l.007-.001 1.128-.48c.757-.322 1.516-.643 2.28-.966 1.146-.483 2.298-.964 3.447-1.437.763-.314 1.53-.627 2.29-.932h-12.41z",
    fill: "#91C45A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3 12.174a7.934 7.934 0 0 0-.22-1.284l-.016-.062-7.385 1.766 7.54 2.798.001.002c.017-.156.032-.3.05-.446.04-.317.076-.818.089-1.178l.002-.1c.012-.52-.01-1.02-.061-1.496z",
    fill: "#20839F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.965 20.699a8.67 8.67 0 0 0-.43-2.129l-5.677 2.018 5.874 2.509c.147-.6.307-1.451.233-2.398z",
    fill: "#5B9E54"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.732 23.097-5.874-2.51 2.893 6.924c2.058-1.47 2.71-3.454 2.717-3.475.08-.259.143-.48.199-.69h.001l.02-.081.014-.049.002-.01c.008-.036.018-.072.028-.11z",
    fill: "#68A855"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.679 12.594 6.18 7.994c.007-.017.755-1.33 1.36-5.196l-7.54-2.798z",
    fill: "#267491"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.495 18.454a8.267 8.267 0 0 0-3.021-3.889 7.347 7.347 0 0 0-1.12-.638l.005-.157c-.013.36-.05.86-.089 1.177-.018.146-.035.29-.05.445-.605 3.866-1.354 5.18-1.362 5.196l5.676-2.017-.04-.117z",
    fill: "#5A9252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightJawwalPay);
export default __webpack_public_path__ + "static/media/lightJawwalPay.9af49899d60c727c6dc443608d8024e1.svg";
export { ForwardRef as ReactComponent };